import React from 'react';

import { AnimatePresence, ErrorMessage } from './Animations';
import { cn } from './cn';
import { formErrorMessageClassName, formLabelClassName } from './formFieldStyles';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, id, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
    return (
      <div className="flex flex-col gap-1.5">
        {label && (
          <label htmlFor={inputId} className={formLabelClassName}>
            {label}
          </label>
        )}
        <input
          id={inputId}
          ref={ref}
          className={cn(
            'h-9 rounded-md border border-gray-300 bg-surface px-3 text-sm text-text-primary outline-none transition-all duration-200 placeholder:text-gray-400 focus:border-info-500 focus:ring-2 focus:ring-info-500/20 focus:shadow-sm',
            error && 'border-danger-400 focus:border-danger-400 focus:ring-danger-400/20',
            className
          )}
          {...props}
        />
        <AnimatePresence>
          {error && <ErrorMessage className={formErrorMessageClassName}>{error}</ErrorMessage>}
        </AnimatePresence>
      </div>
    );
  }
);
Input.displayName = 'Input';
